export const removeDuplicateObjectsFromArray = <T>(array: T[], key: string) => {
  // Declare a new array
  let newArray = [];

  // Declare an empty object
  let uniqueObject = {};

  // Loop for the array elements
  for (let i in array) {
    // Extract the title
    const item1 = array[i][key]?.toString();

    // Use the title as the index
    uniqueObject[item1] = array[i];
  }

  // Loop to push unique object into array
  for (let i in uniqueObject) {
    newArray.push(uniqueObject[i]);
  }

  // Display the unique objects
  return newArray as T[];
};
